/** Model reprezentujący grupę gatunków zwierząt.
 * Służy do grupowania gatunków na widokach wyboru gatunków obsługiwanych przez lecznice.
 */
export class PetSpeciesGroup {

  /** Kod grupy (np. BIRDS) */
  public code: string;
  /** Nazwa grupy w języku polskim */
  public namePl: string;
  /** Indeks kolejności grupy */
  public orderIdx: number;

}
